import {log, callAdminAjax, updateLoadingSpinner, getTemplate, hasKey, getValue, textToParagraphs, normalizeString, nextFrame, sanitizeWpTitle} from './utils.js';
import { doSaveDelete } from './common.js';

const $ = window.jQuery;

/**
 * Initialize the Manage page.
 */
export function initFavoritesPage() {
    log('Manage page initialized');

    initFavoritesPageUI();

}

function initFavoritesPageUI() {
    log('Manage page UI initialized');

    $(document).on('click', '[data-action="removeFromSaved"]', async function(e) {
        e.preventDefault();
        const savedPostId = $(this).data('saved-post-id');
        log('Removing from saved: ' + savedPostId);

        const response = await doSaveDelete(savedPostId);
        if(response) {
            log('Removed from saved successfully.');
            $(this).closest('.col').fadeOut(200, function() {
                $(this).remove();
            });
        } else {
            log('Error removing from saved.');
        }
    });

}